"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Navigo = require("navigo");
var BaseController_1 = require("./controllers/BaseController");
var moment = require("moment");
var FilterController_1 = require("./controllers/FilterController");
var UITableFilterController_1 = require("./controllers/UITableFilterController");
var UIDocumentType;
(function (UIDocumentType) {
    UIDocumentType[UIDocumentType["udtRegularPage"] = 1] = "udtRegularPage";
    UIDocumentType[UIDocumentType["udtMainPage"] = 2] = "udtMainPage";
    UIDocumentType[UIDocumentType["udtLoginPage"] = 3] = "udtLoginPage";
    UIDocumentType[UIDocumentType["udt404Page"] = 4] = "udt404Page";
})(UIDocumentType = exports.UIDocumentType || (exports.UIDocumentType = {}));
var UIGroupType;
(function (UIGroupType) {
    UIGroupType[UIGroupType["ugtGroup"] = 1] = "ugtGroup";
    UIGroupType[UIGroupType["ugtRoot"] = 2] = "ugtRoot";
})(UIGroupType = exports.UIGroupType || (exports.UIGroupType = {}));
var UIItemType;
(function (UIItemType) {
    UIItemType[UIItemType["uitRoute"] = 1] = "uitRoute";
    UIItemType[UIItemType["uitCallBack"] = 2] = "uitCallBack";
})(UIItemType = exports.UIItemType || (exports.UIItemType = {}));
var UIStateController = /** @class */ (function (_super) {
    __extends(UIStateController, _super);
    function UIStateController(errDialog) {
        var _this = _super.call(this, true) || this;
        _this._ROUTER = null;
        _this._FILTER = null;
        _this._UIFILTER = null;
        _this._InitUI = null;
        _this.PAGE_NUM_ONE = 1;
        _this._errDialog = errDialog;
        _this._FILTER = new FilterController_1.FilterController();
        _this._UIFILTER = new UITableFilterController_1.UITableFilterController();
        return _this;
    }
    UIStateController.prototype.ResetData = function () {
        this.DATA = {
            logged: false,
            login: "",
            sign: "",
            groups: [],
            documents: [],
            activeRoute: null,
            activeQuery: null,
            activeDocument: null,
            UI_HEADER_HEIGHT: 110,
            tablePageSize: 100,
            extBreadCrumbPath: [],
            selectedLang: "",
            dtTimeFormat: "YYYY-MM-DD HH:mm:ss",
            dtFrom: moment().subtract(1, 'd').set('hour', 0).set('minute', 0),
            dtTo: moment().add(1, 'd').set('hour', 0).set('minute', 0),
            brands_list: [],
            all_brands: true,
            services_list: [],
            all_services: true,
            country_list: [],
            all_countries: true,
            tags_list: [],
            all_tags: true,
            trackers_list: [],
            all_trackers: true,
            offers_list: [],
            all_offers: true,
            pprograms_list: [],
            all_pprograms: true,
            trust_zones_list: [],
            all_trust_zones: true,
            org_id: 0,
            currency_id: 0,
            all_currency: true,
            deposit_types_list: [1, 11],
            all_deposit_types: false,
            withdraw_types_list: [8, 12],
            all_bonus_states: false,
            bonus_states_list: [3],
            all_withdraw_types: false,
            docFilters: {},
            srvDocuments: {},
            is_full_length_reports: false
        };
    };
    //
    UIStateController.prototype.setInitUICallback = function (callback) {
        this._InitUI = callback;
    };
    //
    UIStateController.prototype.getInitUICallback = function () {
        return this._InitUI;
    };
    //
    UIStateController.prototype.getServerDocument = function (key) {
        return this.DATA.srvDocuments[key];
    };
    //
    UIStateController.prototype.setServerDocument = function (key, doc) {
        this.DATA.srvDocuments[key] = doc;
    };
    //
    UIStateController.prototype.getErrDialog = function () {
        return this._errDialog;
    };
    UIStateController.prototype.getFilter = function () {
        return this._FILTER;
    };
    UIStateController.prototype.getUIFilter = function () {
        return this._UIFILTER;
    };
    //--------------------------------------------------------------------------
    UIStateController.prototype.setIsFullLengthReports = function (fullLength) {
        this.DATA.is_full_length_reports = fullLength;
        this.Update();
    };
    UIStateController.prototype.getIsFullLengthReports = function () {
        return this.DATA.is_full_length_reports;
    };
    //--------------------------------------------------------------------------    
    //--------------------------------------------------------------------------
    UIStateController.prototype.setOrgId = function (id) {
        this.DATA.org_id = id;
        this.Update();
    };
    UIStateController.prototype.getOrgId = function () {
        return this.DATA.org_id;
    };
    //--------------------------------------------------------------------------
    UIStateController.prototype.getTablePageSize = function () {
        return this.DATA.tablePageSize;
    };
    UIStateController.prototype.setTablePageSize = function (val, needUpdate) {
        if (this.DATA.tablePageSize === val) {
            return;
        }
        this.DATA.tablePageSize = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    //-----------------BEGIN TRUST ZONES LIST--------------------------------------
    UIStateController.prototype.setAllTrustZones = function (val, needUpdate) {
        this.DATA.all_trust_zones = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getIsAllTrustZones = function () {
        return this.DATA.all_trust_zones;
    };
    UIStateController.prototype.getTrustZonesList = function () {
        return this.DATA.trust_zones_list;
    };
    UIStateController.prototype.addTrustZone = function (trustZoneId, needUpdate) {
        this.DATA.trust_zones_list.push(trustZoneId);
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.delTrustZone = function (trustZoneId, needUpdate) {
        var new_list = this.DATA.trust_zones_list.slice();
        var index = new_list.indexOf(trustZoneId);
        if (index !== -1) {
            new_list.splice(index, 1);
        }
        this.DATA.trust_zones_list = new_list;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    //-----------------END TRUST ZONES LIST----------------------------------------    
    //-----------------BEGIN PARTNERS LIST--------------------------------------
    UIStateController.prototype.setAllPPrograms = function (val, needUpdate) {
        this.DATA.all_pprograms = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getIsAllPPrograms = function () {
        return this.DATA.all_pprograms;
    };
    UIStateController.prototype.getPProgramsList = function () {
        return this.DATA.pprograms_list;
    };
    UIStateController.prototype.addPProgram = function (pprogramId, needUpdate) {
        this.DATA.pprograms_list.push(pprogramId);
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.delPProgram = function (pprogramId, needUpdate) {
        var new_list = this.DATA.pprograms_list.slice();
        var index = new_list.indexOf(pprogramId);
        if (index !== -1) {
            new_list.splice(index, 1);
        }
        this.DATA.pprograms_list = new_list;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    //-----------------END PARTNERS LIST----------------------------------------
    //-----------------BEGIN CURRENCY LIST--------------------------------------
    UIStateController.prototype.setAllCurrency = function (val, needUpdate) {
        this.DATA.all_currency = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getIsAllCurrency = function () {
        return this.DATA.all_currency;
    };
    UIStateController.prototype.setCurrencyId = function (val, needUpdate) {
        this.DATA.currency_id = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getCurrencyId = function () {
        return this.DATA.currency_id;
    };
    //-----------------END CURRENCY LIST----------------------------------------
    //-----------------BEGIN TAGS LIST------------------------------------------
    UIStateController.prototype.setAllTags = function (val, needUpdate) {
        this.DATA.all_tags = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getIsAllTags = function () {
        return this.DATA.all_tags;
    };
    UIStateController.prototype.getTagsList = function () {
        return this.DATA.tags_list;
    };
    UIStateController.prototype.addTag = function (tagId, needUpdate) {
        this.DATA.tags_list.push(tagId);
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.delTag = function (tagId, needUpdate) {
        var new_list = this.DATA.tags_list.slice();
        var index = new_list.indexOf(tagId);
        if (index !== -1) {
            new_list.splice(index, 1);
        }
        this.DATA.tags_list = new_list;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    //-----------------END TAGS LIST------------------------------------------
    //-----------------BEGIN TRACKERS LIST------------------------------------------
    UIStateController.prototype.setAllTrackers = function (val, needUpdate) {
        this.DATA.all_trackers = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getIsAllTrackers = function () {
        return this.DATA.all_trackers;
    };
    UIStateController.prototype.getTrackersList = function () {
        return this.DATA.trackers_list;
    };
    UIStateController.prototype.addTracker = function (trackerId, needUpdate) {
        this.DATA.trackers_list.push(trackerId);
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.delTracker = function (trackerId, needUpdate) {
        var new_list = this.DATA.trackers_list.slice();
        var index = new_list.indexOf(trackerId);
        if (index !== -1) {
            new_list.splice(index, 1);
        }
        this.DATA.trackers_list = new_list;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    //-----------------END TRACKERS LIST------------------------------------------
    //-----------------BEGIN OFFERS LIST------------------------------------------
    UIStateController.prototype.setAllOffers = function (val, needUpdate) {
        this.DATA.all_offers = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getIsAllOffers = function () {
        return this.DATA.all_offers;
    };
    UIStateController.prototype.getOffersList = function () {
        return this.DATA.offers_list;
    };
    UIStateController.prototype.addOffer = function (offerId, needUpdate) {
        this.DATA.offers_list.push(offerId);
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.delOffer = function (offerId, needUpdate) {
        var new_list = this.DATA.offers_list.slice();
        var index = new_list.indexOf(offerId);
        if (index !== -1) {
            new_list.splice(index, 1);
        }
        this.DATA.offers_list = new_list;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    //-----------------END OFFERS LIST------------------------------------------
    //-----------------BEGIN DEPOSIT TYPES LIST---------------------------------
    UIStateController.prototype.setAllDepositTypes = function (val, needUpdate) {
        this.DATA.all_deposit_types = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getIsAllDepositTypes = function () {
        return this.DATA.all_deposit_types;
    };
    UIStateController.prototype.getDepositTypesList = function () {
        return this.DATA.deposit_types_list;
    };
    UIStateController.prototype.addDepositType = function (depositTypeId, needUpdate) {
        this.DATA.deposit_types_list.push(depositTypeId);
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.delDepositType = function (depositTypeId, needUpdate) {
        var new_list = this.DATA.deposit_types_list.slice();
        var index = new_list.indexOf(depositTypeId);
        if (index !== -1) {
            new_list.splice(index, 1);
        }
        this.DATA.deposit_types_list = new_list;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    //------------------END DEPOSIT TYPES LIST---------------------------------
    //-----------------BEGIN BONUS STATES LIST---------------------------------
    UIStateController.prototype.setAllBonusStates = function (val, needUpdate) {
        this.DATA.all_bonus_states = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getIsAllBonusStates = function () {
        return this.DATA.all_bonus_states;
    };
    UIStateController.prototype.getBonusStatesList = function () {
        return this.DATA.bonus_states_list;
    };
    UIStateController.prototype.addBonusState = function (bonusStateCode, needUpdate) {
        this.DATA.bonus_states_list.push(bonusStateCode);
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.delBonusState = function (bonusSTateCode, needUpdate) {
        var new_list = this.DATA.bonus_states_list.slice();
        var index = new_list.indexOf(bonusSTateCode);
        if (index !== -1) {
            new_list.splice(index, 1);
        }
        this.DATA.bonus_states_list = new_list;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    //------------------END BONUS STATES LIST---------------------------------
    //-----------------BEGIN WITHDRAW TYPES LIST------------------------------
    UIStateController.prototype.setAllWithdrawTypes = function (val, needUpdate) {
        this.DATA.all_withdraw_types = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getIsAllWithdrawTypes = function () {
        return this.DATA.all_withdraw_types;
    };
    UIStateController.prototype.getWithdrawTypesList = function () {
        return this.DATA.withdraw_types_list;
    };
    UIStateController.prototype.addWithdrawType = function (withdrawTypeId, needUpdate) {
        this.DATA.withdraw_types_list.push(withdrawTypeId);
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.delWithdrawType = function (withdrawTypeId, needUpdate) {
        var new_list = this.DATA.withdraw_types_list.slice();
        var index = new_list.indexOf(withdrawTypeId);
        if (index !== -1) {
            new_list.splice(index, 1);
        }
        this.DATA.withdraw_types_list = new_list;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    //-----------------END WITHDRAW TYPES LIST--------------------------------
    //-----------------BEGIN BRANDS LIST--------------------------------------
    UIStateController.prototype.setAllBrands = function (val, needUpdate) {
        this.DATA.all_brands = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getIsAllBrands = function () {
        return this.DATA.all_brands;
    };
    UIStateController.prototype.getBrandsList = function () {
        return this.DATA.brands_list;
    };
    UIStateController.prototype.addBrand = function (brandId, needUpdate) {
        this.DATA.brands_list.push(brandId);
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.delBrand = function (brandId, needUpdate) {
        var new_list = this.DATA.brands_list.slice();
        var index = new_list.indexOf(brandId);
        if (index !== -1) {
            new_list.splice(index, 1);
        }
        this.DATA.brands_list = new_list;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    //-----------------END BRANDS LIST----------------------------------------
    /*
        services_list: number[];
    all_services: boolean;
    */
    //-----------------BEGIN SERVICES LIST--------------------------------------
    UIStateController.prototype.setAllServices = function (val, needUpdate) {
        this.DATA.all_services = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getIsAllServices = function () {
        return this.DATA.all_services;
    };
    UIStateController.prototype.getServicesList = function () {
        return this.DATA.services_list;
    };
    UIStateController.prototype.addService = function (brserviceId, needUpdate) {
        this.DATA.services_list.push(brserviceId);
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.delService = function (brserviceId, needUpdate) {
        var new_list = this.DATA.services_list.slice();
        var index = new_list.indexOf(brserviceId);
        if (index !== -1) {
            new_list.splice(index, 1);
        }
        this.DATA.services_list = new_list;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    //-----------------END SERVICES LIST----------------------------------------
    //-----------------BEGIN COUNTRY LIST--------------------------------------
    UIStateController.prototype.setAllCountries = function (val, needUpdate) {
        this.DATA.all_countries = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getIsAllCountries = function () {
        return this.DATA.all_countries;
    };
    UIStateController.prototype.getCountriesList = function () {
        return this.DATA.country_list;
    };
    UIStateController.prototype.addCountry = function (countryId, needUpdate) {
        this.DATA.country_list.push(countryId);
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.delCountry = function (countryId, needUpdate) {
        var new_list = this.DATA.country_list.slice();
        var index = new_list.indexOf(countryId);
        if (index !== -1) {
            new_list.splice(index, 1);
        }
        this.DATA.country_list = new_list;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    //-----------------END COUNTRY LIST----------------------------------------
    UIStateController.prototype.setDateTimeFormat = function (val, needUpdate) {
        this.DATA.dtTimeFormat = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getDateTimeFormat = function () {
        return this.DATA.dtTimeFormat;
    };
    UIStateController.prototype.setDateFrom = function (val, needUpdate) {
        this.DATA.dtFrom = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getDateFrom = function () {
        return this.DATA.dtFrom;
    };
    UIStateController.prototype.setDateTo = function (val, needUpdate) {
        this.DATA.dtTo = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getDateTo = function () {
        return this.DATA.dtTo;
    };
    UIStateController.prototype.setLang = function (lang, needUpdate) {
        this.DATA.selectedLang = lang;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    UIStateController.prototype.getLang = function () {
        return this.DATA.selectedLang;
    };
    UIStateController.prototype.setExtBreadCrumbPath = function (extPath) {
        this.DATA.extBreadCrumbPath = extPath;
        this.Update();
        return this;
    };
    UIStateController.prototype.getRegisteredDocuments = function () {
        return this.DATA.documents;
    };
    Object.defineProperty(UIStateController.prototype, "UIHeaderHeightPx", {
        get: function () {
            return this.DATA.UI_HEADER_HEIGHT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UIStateController.prototype, "UITablePageSize", {
        get: function () {
            return this.DATA.tablePageSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UIStateController.prototype, "UITablePageSizeOptions", {
        get: function () {
            return ["10", "15", "20", "30", "40", "50", "100", "200", "300", "400", "500"];
        },
        enumerable: true,
        configurable: true
    });
    UIStateController.prototype.AddGroup = function (Ico, Title, GroupId, GroupType) {
        var _group = {
            groupType: GroupType,
            icon: Ico,
            groupId: GroupId,
            items: [],
            title: Title
        };
        this.DATA.groups.push(_group);
        return _group;
    };
    UIStateController.prototype.RemoveGroup = function (GroupId) {
        var tmp = [];
        var found = false;
        for (var i = 0; i < this.DATA.groups.length; i++) {
            if (this.DATA.groups[i].groupId != GroupId) {
                tmp.push(this.DATA.groups[i]);
            }
            else {
                found = true;
            }
        }
        if (found) {
            this.DATA.groups = tmp;
        }
        return this;
    };
    UIStateController.prototype.IsGroupEmpty = function (GroupId) {
        var found = false;
        for (var i = 0; i < this.DATA.groups.length; i++) {
            if (this.DATA.groups[i].groupId == GroupId) {
                found = true;
                if (this.DATA.groups[i].items.length == 0) {
                    return true;
                }
            }
        }
        return false;
    };
    UIStateController.prototype.GetGroupDocsCount = function (GroupId) {
        var found = false;
        for (var i = 0; i < this.DATA.groups.length; i++) {
            if (this.DATA.groups[i].groupId == GroupId) {
                found = true;
                return this.DATA.groups[i].items.length;
            }
        }
        return -1;
    };
    UIStateController.prototype.GetGroupsIdList = function () {
        var _ret = [];
        for (var i = 0; i < this.DATA.groups.length; i++) {
            _ret.push(this.DATA.groups[i].groupId);
        }
        return _ret;
    };
    UIStateController.prototype.AddItemByTypeCallBack = function (Ico, Title, GroupId, ItemId, CallBack) {
        var _groupIdx = -1;
        for (var i = 0; i < this.DATA.groups.length; i++) {
            if (this.DATA.groups[i].groupId === GroupId) {
                _groupIdx = i;
                break;
            }
        }
        if (_groupIdx < 0) {
            throw "Group with id : " + GroupId + " not found!";
        }
        this.DATA.groups[_groupIdx].items.push({
            itemType: UIItemType.uitCallBack,
            itemId: ItemId,
            icon: Ico,
            iconKind: "normal",
            title: Title,
            route: "",
            callback: CallBack
        });
        return this;
    };
    UIStateController.prototype.AddItemByTypeDocument = function (DocInfo, GroupId) {
        var _groupIdx = -1;
        for (var i = 0; i < this.DATA.groups.length; i++) {
            if (this.DATA.groups[i].groupId === GroupId) {
                _groupIdx = i;
                break;
            }
        }
        if (_groupIdx < 0) {
            throw "Group with id : " + GroupId + " not found!";
        }
        this.DATA.groups[_groupIdx].items.push({
            itemType: UIItemType.uitRoute,
            itemId: DocInfo.itemId,
            icon: DocInfo.icon,
            iconKind: DocInfo.iconKind,
            title: DocInfo.itemTitle,
            route: DocInfo.route,
            callback: null
        });
        return this;
    };
    UIStateController.prototype.RemoveItemByTypeDocument = function (Route, GroupId) {
        var _groupIdx = -1;
        for (var i = 0; i < this.DATA.groups.length; i++) {
            if (this.DATA.groups[i].groupId == GroupId) {
                _groupIdx = i;
                break;
            }
        }
        if (_groupIdx >= 0) {
            //alert('found!');
            var _items_old = this.DATA.groups[_groupIdx].items;
            var _items_new = [];
            for (var i = 0; i < _items_old.length; i++) {
                if (_items_old[i].route != Route) {
                    _items_new.push(_items_old[i]);
                } // else {
                //  alert('skipped!');
                // }
            }
            this.DATA.groups[_groupIdx].items = _items_new;
        }
        else {
            alert('not found!');
        }
        return this;
    };
    UIStateController.prototype.AddDocument = function (Doc, Info) {
        for (var i = 0; i < this.DATA.documents.length; i++) {
            if (this.DATA.documents[i].info.route === Info.route) {
                throw "Route : " + Info.route + " already exists !";
            }
        }
        var _doc = {
            doc: Doc,
            info: Info,
        };
        this.DATA.documents.push(_doc);
        return this;
    };
    UIStateController.prototype.RemoveDocument = function (Route) {
        var tmp = [];
        for (var i = 0; i < this.DATA.documents.length; i++) {
            if (this.DATA.documents[i].info.route != Route) {
                tmp.push(this.DATA.documents[i]);
            }
        }
        this.DATA.documents = tmp;
        return this;
    };
    UIStateController.prototype.SetMainDocument = function (Route) {
        // let tmp: IUIDocument[] = [];
        for (var i = 0; i < this.DATA.documents.length; i++) {
            if (this.DATA.documents[i].info.route == Route) {
                this.DATA.documents[i].doc.type = UIDocumentType.udtMainPage;
                break;
            }
        }
        // this.DATA.documents = tmp;
        return this;
    };
    UIStateController.prototype.GetDocument = function (Route) {
        // let tmp: IUIDocument[] = [];
        for (var i = 0; i < this.DATA.documents.length; i++) {
            if (this.DATA.documents[i].info.route == Route) {
                return this.DATA.documents[i];
            }
        }
        // this.DATA.documents = tmp;
        //   return this;
    };
    UIStateController.prototype.GetItemByRoute = function (Route) {
        if (Route) {
            for (var i = 0; i < this.DATA.groups.length; i++) {
                for (var j = 0; j < this.DATA.groups[i].items.length; j++) {
                    if (this.DATA.groups[i].items[j].route === Route) {
                        return this.DATA.groups[i].items[j];
                    }
                }
            }
        }
        return null;
    };
    UIStateController.prototype.GetItemByItemId = function (itemId) {
        for (var i = 0; i < this.DATA.groups.length; i++) {
            for (var j = 0; j < this.DATA.groups[i].items.length; j++) {
                if (this.DATA.groups[i].items[j].itemId === itemId) {
                    return this.DATA.groups[i].items[j];
                }
            }
        }
        throw "UIStateController->GetItemByItemId : " + itemId + " not found!";
    };
    UIStateController.prototype.GetGroupByRoute = function (Route) {
        if (Route) {
            for (var i = 0; i < this.DATA.groups.length; i++) {
                for (var j = 0; j < this.DATA.groups[i].items.length; j++) {
                    if (this.DATA.groups[i].items[j].route === Route) {
                        return this.DATA.groups[i];
                    }
                }
            }
        }
        return null;
    };
    UIStateController.prototype.GetGroupByItemId = function (itemId) {
        for (var i = 0; i < this.DATA.groups.length; i++) {
            for (var j = 0; j < this.DATA.groups[i].items.length; j++) {
                if (this.DATA.groups[i].items[j].itemId === itemId) {
                    return this.DATA.groups[i];
                }
            }
        }
        throw "UIStateController->GetGroupByItemId : " + itemId + " not found!";
    };
    UIStateController.prototype.SetLogged = function (login, sign, restorePage) {
        this.DATA.login = login;
        this.DATA.sign = sign;
        this.DATA.logged = true;
        if (restorePage) {
            if (localStorage.hasOwnProperty("mg-route")) {
                this._ROUTER.navigate(localStorage.getItem("mg-route"));
            }
            else {
                this.NavigateMainPage();
            }
        }
        else {
            this.NavigateMainPage();
        }
    };
    UIStateController.prototype.SetUnLogged = function () {
        this.DATA.login = "";
        this.DATA.sign = "";
        this.DATA.logged = false;
        this.NavigateLoginPage();
    };
    UIStateController.prototype.GetUserLogin = function () {
        return this.DATA.login;
    };
    UIStateController.prototype.RegisterPagesRoutesHandlers = function () {
        var _this = this;
        //alert(`RegisterPagesRoutesHandlers1->${document.URL}`);
        if (!this._ROUTER) {
            this._ROUTER = new Navigo(null, true, "#");
        }
        var handlers = {};
        var _loop_1 = function (i) {
            var key = "" + this_1.DATA.documents[i].info.route;
            var item = this_1.DATA.documents[i];
            handlers[key] = function (param, query) {
                _this.SelectDocument(item.info.route, query);
            };
        };
        var this_1 = this;
        for (var i = 0; i < this.DATA.documents.length; i++) {
            _loop_1(i);
        }
        handlers["*"] = function (param, query) {
            _this.Select404Page();
        };
        //BEGIN HANDLE PARAMETERS-------------------------------------------------------------
        var _refKey = "ref";
        var _hasRef = false;
        var _refVal = "";
        if (localStorage.hasOwnProperty("" + _refKey)) {
            var _ref = localStorage.getItem("" + _refKey);
            //localStorage.removeItem()
            if (!isNaN(parseInt(_refKey))) {
                _hasRef = true;
                _refVal = localStorage.getItem("" + _refKey);
            }
        }
        //localStorage.clear();
        var arrUrl = document.URL.split("?");
        if (arrUrl.length == 2) {
            localStorage.clear();
            var arrParam = arrUrl[1].split("&");
            for (var i = 0; i < arrParam.length; i++) {
                var keyVal = arrParam[i].split("=");
                if (keyVal.length == 2) {
                    localStorage.setItem(keyVal[0], keyVal[1]);
                }
            }
        }
        if (_hasRef) {
            localStorage.setItem(_refKey, _refVal);
        }
        //END HANDLE PARAMETERS-----------------------------------------------------------------
        //alert(`RegisterPagesRoutesHandlers2->${document.URL}`);
        this._ROUTER.on(handlers).resolve();
        //alert(`RegisterPagesRoutesHandlers3->${document.URL}`);
    };
    UIStateController.prototype.ClearPagesRoutesHandlers = function () {
        if (this._ROUTER) {
            this._ROUTER.destroy();
            this._ROUTER = null;
        }
    };
    UIStateController.prototype.SelectDocument = function (documentRoute, query) {
        for (var i = 0; i < this.DATA.documents.length; i++) {
            if (this.DATA.documents[i].info.route === documentRoute) {
                var skipWrite = false;
                if (this.DATA.documents[i].info.docType == UIDocumentType.udtLoginPage) {
                    skipWrite = true;
                }
                if (this.DATA.documents[i].info.docType == UIDocumentType.udt404Page) {
                    skipWrite = true;
                }
                if (!skipWrite) {
                    localStorage.setItem("mg-route", documentRoute);
                }
                if (!this.DATA.logged) {
                    if (this.DATA.documents[i].info.docType !== UIDocumentType.udtLoginPage) {
                        this.NavigateLoginPage();
                        return;
                    }
                }
                else {
                    if (this.DATA.documents[i].info.docType === UIDocumentType.udtLoginPage) {
                        this.Select404Page();
                        return;
                    }
                }
                this.DATA.activeRoute = this.DATA.documents[i].info.route;
                this.DATA.activeQuery = query;
                this.DATA.activeDocument = this.DATA.documents[i].doc;
                this.DATA.extBreadCrumbPath = [];
                this.Update();
                return;
            }
        }
        this.Select404Page();
    };
    UIStateController.prototype.NavigateMainPage = function () {
        this._ROUTER.navigate(this.getDocumentDescriptionByType(UIDocumentType.udtMainPage).route);
    };
    UIStateController.prototype.NavigateLoginPage = function () {
        if (this.DATA.logged) {
            this.Select404Page();
        }
        else {
            this._ROUTER.navigate(this.getDocumentDescriptionByType(UIDocumentType.udtLoginPage).route);
        }
    };
    UIStateController.prototype.NavigateItem = function (item) {
        if (item.itemType == UIItemType.uitCallBack) {
            this.Select404Page();
        }
        else {
            this._ROUTER.navigate(item.route);
        }
    };
    UIStateController.prototype.NavigateDocument = function (item) {
        if (item.info.docType == UIDocumentType.udtRegularPage) {
            this._ROUTER.navigate(item.info.route);
        }
        else {
            this.Select404Page();
        }
    };
    UIStateController.prototype.NavigateDocumentDescription = function (info) {
        if ((info.docType == UIDocumentType.udtRegularPage) || (info.docType == UIDocumentType.udtMainPage)) {
            this._ROUTER.navigate(info.route);
        }
        else {
            this.Select404Page();
        }
    };
    UIStateController.prototype.Select404Page = function () {
        if (this.DATA.logged) {
            this.DATA.activeRoute = null;
            this.DATA.activeQuery = null;
            this.DATA.activeDocument = this.getDocumentInstanceByType(UIDocumentType.udt404Page);
            this.Update();
        }
        else {
            this.NavigateLoginPage();
        }
    };
    UIStateController.prototype.getDocumentDescriptionByType = function (dType) {
        for (var i = 0; i < this.DATA.documents.length; i++) {
            if (this.DATA.documents[i].info.docType === dType) {
                return this.DATA.documents[i].info;
            }
        }
        return null;
    };
    UIStateController.prototype.getDocumentInstanceByType = function (dType) {
        for (var i = 0; i < this.DATA.documents.length; i++) {
            if (this.DATA.documents[i].info.docType === dType) {
                return this.DATA.documents[i].doc;
            }
        }
        return null;
    };
    UIStateController.prototype.boolToStr = function (val) {
        if (val) {
            return "Да";
        }
        else {
            return "Нет";
        }
    };
    return UIStateController;
}(BaseController_1.BaseController));
exports.UIStateController = UIStateController;



//////////////////
// WEBPACK FOOTER
// ./src/shared/UiStateController.ts
// module id = 27
// module chunks = 0